




























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import SelectChannelModal from "@/components/channels/modals/SelectChannelModal.vue";
import SelectChannelGroupModal from "@/components/channels/modals/SelectChannelGroupModal.vue";
import SelectStageModal from "@/components/stages/modals/SelectStageModal.vue";
// types
import i18n from "@/i18n";
import { Content, ContentType, ContentStatusEnum } from "@/services/templates/types";
import { Guid } from "guid-typescript";
import { contentFields } from "@/components/templates/fields/contentFields";
// validation
import validate from "@/directives/validate";
import {
    addContentValidators,
    removeContentValidators
} from "@/components/templates/validators";

@Component({
    components: {
        "select-channel-modal": SelectChannelModal,
        "select-channel-group-modal": SelectChannelGroupModal,
        "select-stage-modal": SelectStageModal
    },
    directives: {
        validate
    }
})
export default class TemplateContent extends Vue {
    @Prop() content!: Content[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localContent = [] as Content[];
    fields = contentFields;
    validators = {};
    contentStatusEnum = ContentStatusEnum;
    tableKey = 0;
    // Watchers
    @Watch("content")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localContent = this.content;
        this.localContent.sort((a, b) => b.layer - a.layer);
        if (this.localContent.length > 0) {
            this.localContent.forEach(x => {
                addContentValidators(this.validators, x.id);
            });
        }
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }
    // computed

    // methods
    addChannel() {
        (this.$refs.selectChannelModal as any).open(true);
    }

    addChannelGroup() {
        (this.$refs.selectChannelGroupModal as any).open(true);
    }

    addStage() {
        (this.$refs.selectStageModal as any).open(true);
    }

    addContent(contentId: string, contentName: string, contentType: ContentType) {
        if (!this.localContent) { this.localContent = [] as Content[]; }
        const maxLayer = Math.max.apply(Math, this.localContent.map(function (o) { return o.layer; }));

        const content = {} as Content;
        content.id = Guid.create().toString();
        content.contentId = contentId;
        content.name = contentName;
        content.type = contentType;
        content.typeName = this.getContentTypeName(content.type);
        content.layer = maxLayer > 0 ? maxLayer + 1 : 1000;
        content.status = ContentStatusEnum.Active;

        addContentValidators(this.validators, content.id);
        this.localContent.push(content);
        this.localContent.sort((a, b) => b.layer - a.layer);
        // recreate the table so the validators to be appropriately reattached
        this.tableKey++;
    }

    getContentTypeName(type: ContentType) {
        return i18n.t(`background.contentTypes.${ContentType[type].toLowerCase()}`).toString();
    }

    deleteContent(id: string) {
        const item = this.localContent.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localContent.splice(this.localContent.indexOf(item), 1);
        this.$nextTick(() => {
            removeContentValidators(this.validators, item.id);
        });
    }

    // events && callbacks
    channelSelected(channels: any) {
        channels.forEach((channel: any) => {
            this.addContent(channel.id, channel.name, ContentType.Channel);
        });
    }

    channelGroupSelected(channelGroup: any) {
        channelGroup.forEach((channelGroup: any) => {
            this.addContent(channelGroup.id, channelGroup.name, ContentType.ChannelGroup);
        });
    }

    stageSelected(stage: any) {
        stage.forEach((stage: any) => {
            this.addContent(stage.id, stage.name, ContentType.Stage);
        });
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("contentUpdated", JSON.parse(JSON.stringify(this.localContent)));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "TemplateContent", state: state });
    }

    goToContentRoute(model: Content) {
        if (model.type === ContentType.Channel) {
            return {
                name: "updatechannel",
                params: { channelId: model.contentId }
            };
        }
        if (model.type === ContentType.ChannelGroup) {
            return {
                name: "UpdateChannelGroup",
                params: { channelGroupId: model.contentId }
            };
        }
        return {
            name: "updateStage",
            params: { stageId: model.contentId }
        };
    }

    calculateTooltipText(model: Content) {
        if (model.type === ContentType.Channel) {
            return i18n.t("channels.editTitle").toString();
        }
        if (model.type === ContentType.ChannelGroup) {
            return i18n.t("channelGroups.editChannelGroup").toString();
        }
        return i18n.t("channels.stage").toString();
    }

    toggleActive(item: Content) {
        if (item.status === this.contentStatusEnum.Active) {
            item.status = this.contentStatusEnum.Disabled;
        } else {
            item.status = this.contentStatusEnum.Active;
        }
    }
}
